import { z } from "zod";
import {
  ECompanyInformationSection,
  TCompanyInformationSection,
} from "./ECompanyInformationSection";
import { schemes } from "../schema-validation";

export type TCompanyShareableLinkSectionTitleForEmail = "agreements";

export const companyShareableLinkSectionToEmailTitleMap: Record<
  TCompanyInformationSection,
  TCompanyShareableLinkSectionTitleForEmail
> = {
  [ECompanyInformationSection.AGREEMENTS]: "agreements",
};

export const companyInformationSectionSchema = z.object({
  name: z.nativeEnum(ECompanyInformationSection),
});

export const companyShareableLinksTokenPayloadSchema = z.object({
  companyID: schemes.companyID(),
  isShareableLink: z.literal(true),
  sections: z.array(companyInformationSectionSchema),
  testMode: z.boolean(),
  whiteLabelID: z.string(),
});

export const companyInformationCompanySchema = z.object({
  company_id: schemes.companyID(),
  business_name: z.string(),
  direct_deposit_form: z.boolean().optional(),
  deposit_account_form: z.boolean().optional(),
  electronic_communication_form: z.boolean().optional(),
  patriot_act_form: z.boolean().optional(),
  puzzl_terms_conditions: z.boolean().optional(),
  reporting_agent_form: z.boolean().optional(),
  tax_information_authorization_form: z.boolean().optional(),
});

export const companyInformationPayloadSchema = z.object({
  company: companyInformationCompanySchema,
  logoURL: z.string().nullish(),
  tokenPayload: companyShareableLinksTokenPayloadSchema,
});

export type TCompanyShareableLinksSection = z.infer<
  typeof companyInformationSectionSchema
>;
export type TCompanyShareableLinksTokenPayload = z.infer<
  typeof companyShareableLinksTokenPayloadSchema
>;
export type TCompanyInformationPayload = z.infer<
  typeof companyInformationPayloadSchema
>;
